var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{attrs:{"size":_vm.size}},[(_vm.userId)?_c('img',{attrs:{"src":_vm.avatarUrl,"alt":_vm.getDisplayName}}):_c('v-icon',{attrs:{"medium":""}},[_vm._v(_vm._s(_vm.defaultIcon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }